import axios from "axios";

const baseURL = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_BACKEND}${process.env.REACT_APP_API}`

const API = axios.create({
    baseURL: baseURL,
    withToken: true,
    headers: {
        "Content-Type": "application/json",
    },
});

API.interceptors.request.use((config) => {
    if (config.withToken) {
        const token = localStorage.token || sessionStorage.token;
        if (token) {
            // eslint-disable-next-line no-param-reassign
            config.headers.common.Authorization = `Bearer ${
                localStorage.token || sessionStorage.token
            }`;
        }
    }

    return config;
});

export default API;
